import { serviceInstance } from 'libs';

export default {
  login: (body) =>
    serviceInstance.post('login', body).then(({ data, status }) => ({
      ...data,
    })),
  forgotPassword: (email) =>
    serviceInstance.put(`/password/reset?email=${email}`).then(({ data }) => ({
      ...data,
    })),
  verifyToken: (body) =>
    serviceInstance.post('/password/verify-token', body).then(({ data }) => ({
      ...data,
    })),
  changePassword: (body) =>
    serviceInstance.put('/password/change', body).then(({ data }) => ({
      ...data,
    })),
  resetPassword: (body) =>
    serviceInstance.put('/password/update', body).then(({ data }) => ({
      ...data,
    })),
  createAccount: (body) =>
    serviceInstance.post('api/merchant/create', body).then(({ data }) => ({
      ...data,
    })),
  setPassword: (body, invitationId) =>
    serviceInstance
      .put(`merchant/users/${invitationId}/invitation`, null, {
        params: { password: body },
      })
      .then(({ data }) => ({
        ...data,
      })),
  setPin: (body, merchantId) =>
    serviceInstance
      .post(`/settings/merchant/${merchantId}/settlement-password`, body)
      .then(({ data }) => ({
        ...data,
      })),
  changePin: (body, merchantId) =>
    serviceInstance
      .put(`/settings/merchant/${merchantId}/settlement-password`, body)
      .then(({ data }) => ({
        ...data,
      })),
  resendVerificationEmail: (emailAddress) =>
    serviceInstance
      .post(`/verification/email/${emailAddress}/token/resend`)
      .then(({ data }) => ({
        ...data,
      })),
  verifyEmailToken: (token, email) =>
    serviceInstance
      .post(`/verification/email/${email}/token/${token}`)
      .then(({ data }) => ({
        ...data,
      })),
};
